import Footer from "../components/Footer";
import IntroSiKembar from "../components/SiKembarIntro";
import SiKembarBook from "../components/SiKembarBook";
import CtaSiKembar from "../components/SiKembarCta";
import SiKembarFAQ from "../components/SiKembarFAQ";

import HomeLearning from "../components/HomeLearning";
import Seo from "../components/Seo";
import { URLS } from "../utils/constants";

const UniverseKembarPintar = () => {
  const meta = URLS.siKembarPintar;

  return (
    <div className="universe-page">
      <Seo title={meta.title} description={meta.desc} keywords={meta.keywords} image={meta.metaImage} path={meta.path} />
      <h1 className="visually-hidden">{meta.title}</h1>
      <IntroSiKembar />

      <SiKembarBook />

      <HomeLearning type={2} />

      <SiKembarFAQ />

      <CtaSiKembar />

      <Footer />
    </div>
  );
};

export default UniverseKembarPintar;
